var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.53514 97.535L0.464844 90.4647L41.9298 48.9997L0.464844 7.53466L7.53514 0.464355L56.0701 48.9994L7.53514 97.5344","fill":"white"}));
}

ArrowRightInline.defaultProps = {"width":"57","height":"98","viewBox":"0 0 57 98","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
